import { HttpClient } from '@angular/common/http';
import { TranslateLoader } from '@ngx-translate/core';
import { Observable, forkJoin, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

export class MultiTranslateLoader implements TranslateLoader {
  constructor(
    private http: HttpClient,
    public resources: { projectName: string; moduleName: string }[],
  ) {}

  public getTranslation(lang: string): Observable<any> {
    return forkJoin(
      this.resources.map((config) =>
        this.http.get(`assets/${config.projectName}/${config.moduleName}/locale/${lang}.json`).pipe(
          catchError((error) => {
            console.error(`Could not load translations for lang: ${lang}`, error);
            return of({});
          }),
        ),
      ),
    ).pipe(map((response) => Object.assign({}, ...response)));
  }
}
